$(function () {

    var navItems = document.querySelectorAll(".mobile-bottom-nav__item");

    navItems.forEach(function (e, i) {
        e.addEventListener("click", function (e) {
            navItems.forEach(function (e2, i2) {
                e2.classList.remove("mobile-bottom-nav__item--active");
            });
            this.classList.add("mobile-bottom-nav__item--active");
        });
    });
});


$(document).ready(function () {

    var upbtn = $('#up-btn');

    upbtn.on('click', function (e) {
        e.preventDefault();
        $('html,body').animate({
            scrollTop: 0
        }, 700);
    });
});